<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>
        <div class="mb-4">
          <label class="label-input">Title</label>
          <ckeditor :editor="editor" v-model="fields.socialMediaTitle" :config="editorConfig" />
        </div>
        <v-row>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="backgroundColor"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].backgroundColor"
                @change="handleChangeBackgroundColor"
              />
              <v-text-field v-model="fields['colors'].backgroundColor" label="Background Color" />
              <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
          <v-col md="6" cols="12">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="borderColor"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields['colors'].borderColor"
                @change="handleChangeBorderColor"
              />
              <v-text-field v-model="fields['colors'].borderColor" label="Border Color" />
              <v-btn @click="handleResetBorderColor" small text color="primary"> Reset </v-btn>
            </div>
          </v-col>
        </v-row>
        <div class="mt-6">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input" style="margin-bottom: 10px">Posts ({{ fields['posts'].length || 0 }})</label>
            <v-btn small text color="primary" @click="handleAddPost">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Post</span>
            </v-btn>
          </div>
          <v-row>
            <v-col md="4" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="postWrapperBackgroundColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].postWrapperBackgroundColor"
                  @change="handleChangePostWrapperBackgroundColor"
                />
                <v-text-field
                  v-model="fields['colors'].postWrapperBackgroundColor"
                  label="Post Wrapper Background Color"
                />
                <v-btn @click="handleResetPostWrapperBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="4" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="postBackgroundColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].postBackgroundColor"
                  @change="handleChangePostBackgroundColor"
                />
                <v-text-field v-model="fields['colors'].postBackgroundColor" label="Post Background Color" />
                <v-btn @click="handleResetPostBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="4" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="postTextColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].postTextColor"
                  @change="handleChangePostTextColor"
                />
                <v-text-field v-model="fields['colors'].postTextColor" label="Post Text Color" />
                <v-btn @click="handleResetPostTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="4" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="commentBackgroundColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].commentBackgroundColor"
                  @change="handleChangeCommentBackgroundColor"
                />
                <v-text-field v-model="fields['colors'].commentBackgroundColor" label="Comment Background Color" />
                <v-btn @click="handleResetCommentBackgroundColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
            <v-col md="4" cols="12">
              <div class="d-flex align-center gap-3">
                <input
                  type="color"
                  name="commentTextColor"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['colors'].commentTextColor"
                  @change="handleChangeCommentTextColor"
                />
                <v-text-field v-model="fields['colors'].commentTextColor" label="Comment Text Color" />
                <v-btn @click="handleResetCommentTextColor" small text color="primary"> Reset </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(post, postIndex) in fields['posts']" :key="postIndex">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <div class="post-content-text">
                    {{ fields['posts'][postIndex].content }}
                  </div>
                  <v-btn icon @click.stop="handleRemovePost(postIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mt-4">
                  <v-text-field
                    class="mb-4"
                    v-model="fields['posts'][postIndex].author.name"
                    label="Author Name"
                    dense
                  />
                  <div>
                    <p>Author Avatar</p>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, postIndex, 'post')"
                      :image="{ imageSrc: fields['posts'][postIndex].author.avatar }"
                      :height="`100`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveImage(postIndex, 'post')"
                    />
                  </div>
                  <v-textarea
                    class="mt-8"
                    label="Content"
                    outlined
                    v-model="fields['posts'][postIndex].content"
                  ></v-textarea>
                  <v-row>
                    <v-col md="4" cols="12">
                      <v-text-field
                        class="mb-4"
                        label="Reaction Count"
                        dense
                        v-model="fields['posts'][postIndex].reactionCount"
                      />
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field
                        class="mb-4"
                        label="Comment Count"
                        dense
                        v-model="fields['posts'][postIndex].commentCount"
                      />
                    </v-col>
                    <v-col md="4" cols="12">
                      <v-text-field
                        class="mb-4"
                        label="Created At"
                        dense
                        v-model="fields['posts'][postIndex].createdAt"
                      />
                    </v-col>
                  </v-row>
                  <div>
                    <div class="d-flex justify-space-between align-center mb-2">
                      <div>Comments ({{ (post && post.comments && post.comments.length) || 0 }})</div>
                      <v-btn small text color="primary" @click="handleAddComment(postIndex)">
                        <v-icon size="16">mdi-plus</v-icon>
                        <span>Add Comment</span>
                      </v-btn>
                    </div>
                    <v-expansion-panels accordion>
                      <v-expansion-panel
                        v-for="(_, commentIndex) in post && post.comments ? post.comments : []"
                        :key="commentIndex"
                      >
                        <v-expansion-panel-header>
                          <div class="d-flex justify-space-between align-center">
                            <div class="comment-content-text">
                              {{ fields['posts'][postIndex].comments[commentIndex].content }}
                            </div>
                            <v-btn icon @click.stop="handleRemoveComment(postIndex, commentIndex)">
                              <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-text-field
                            class="mb-4"
                            v-model="fields['posts'][postIndex].comments[commentIndex].author.name"
                            label="Author Name"
                            dense
                          />
                          <div>
                            <p>Author Avatar</p>
                            <UploadImage
                              @callback="obj => handleUploadImage(obj, commentIndex, 'comment')"
                              :image="{ imageSrc: fields['posts'][postIndex].comments[commentIndex].author.avatar }"
                              :height="`100`"
                              :typeUpload="'image'"
                              @callbackDelete="handleRemoveImage(commentIndex, 'comment')"
                            />
                          </div>
                          <v-textarea
                            class="mt-8"
                            label="Content"
                            outlined
                            v-model="fields['posts'][postIndex].comments[commentIndex].content"
                          ></v-textarea>
                          <v-text-field
                            class="mb-4"
                            v-model="fields['posts'][postIndex].comments[commentIndex].createdAt"
                            label="Created At"
                            dense
                          />
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
import productReviewsJson from '@/assets/json/product-reviews.json';

export default {
  name: 'social-media-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        socialMediaTitle: "It's Going Viral on Social Media",
        colors: {
          backgroundColor: '#ffffff',
          postWrapperBackgroundColor: '#f0f2f5',
          postBackgroundColor: '#ffffff',
          postTextColor: '#000000',
          commentBackgroundColor: '#f0f2f5',
          commentTextColor: '#000000',
          borderColor: '#e5e7eb',
        },
        topPadding: true,
        bottomPadding: true,
        posts: [
          // example post
          // {
          //   content: '',
          //   createdAt: '',
          //   author: {
          //     name: '',
          //     avatar: '',
          //   },
          //   commentCount: 0,
          //   reactionCount: 0,
          //   comments: [
          //     {
          //       content: '',
          //       author: {
          //         name: '',
          //         avatar: '',
          //       },
          //       createdAt: '',
          //     },
          //   ],
          // },
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddComment(postIndex) {
      const randomComment = productReviewsJson[Math.floor(Math.random() * productReviewsJson.length)];
      this.fields['posts'][postIndex].comments.push({
        content: 'Enter comment content here...',
        author: {
          name: randomComment.fullName,
          avatar: randomComment.avatar,
        },
        createdAt: '2 days ago',
      });
    },
    handleAddPost() {
      const randomComment = productReviewsJson[Math.floor(Math.random() * productReviewsJson.length)];
      this.fields['posts'].push({
        content: 'Enter post content here...',
        createdAt: '2 days ago',
        author: {
          name: randomComment.fullName,
          avatar: randomComment.avatar,
        },
        commentCount: 0,
        reactionCount: 0,
        comments: [],
      });
    },
    handleRemovePost(index) {
      this.fields['posts'].splice(index, 1);
    },
    handleRemoveComment(postIndex, commentIndex) {
      this.fields['posts'][postIndex].comments.splice(commentIndex, 1);
    },
    handleUploadImage(obj, index, type) {
      if (type === 'post') {
        this.fields['posts'][index].author.avatar = obj.imageSrc;
      } else if (type === 'comment') {
        this.fields['posts'][index].comments[index].author.avatar = obj.imageSrc;
      }
    },
    handleRemoveImage(index, type) {
      if (type === 'post') {
        this.fields['posts'][index].author.avatar = '';
      } else if (type === 'comment') {
        this.fields['posts'][index].comments[index].author.avatar = '';
      }
    },
    handleChangeBackgroundColor(event) {
      this.fields['colors'].backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['colors'].backgroundColor = '#ffffff';
    },
    handleChangePostWrapperBackgroundColor(event) {
      this.fields['colors'].postWrapperBackgroundColor = event.target.value;
    },
    handleResetPostWrapperBackgroundColor() {
      this.fields['colors'].postWrapperBackgroundColor = '#f0f2f5';
    },
    handleChangePostBackgroundColor(event) {
      this.fields['colors'].postBackgroundColor = event.target.value;
    },
    handleResetPostBackgroundColor() {
      this.fields['colors'].postBackgroundColor = '#ffffff';
    },
    handleChangePostTextColor(event) {
      this.fields['colors'].postTextColor = event.target.value;
    },
    handleResetPostTextColor() {
      this.fields['colors'].postTextColor = '#000000';
    },
    handleChangeCommentBackgroundColor(event) {
      this.fields['colors'].commentBackgroundColor = event.target.value;
    },
    handleResetCommentBackgroundColor() {
      this.fields['colors'].commentBackgroundColor = '#f0f2f5';
    },
    handleChangeCommentTextColor(event) {
      this.fields['colors'].commentTextColor = event.target.value;
    },
    handleResetCommentTextColor() {
      this.fields['colors'].commentTextColor = '#000000';
    },
    handleChangeBorderColor(event) {
      this.fields['colors'].borderColor = event.target.value;
    },
    handleResetBorderColor() {
      this.fields['colors'].borderColor = '#e5e7eb';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSocialMedia(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 100px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.post-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  font-weight: 500;
}
.comment-content-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
</style>
